/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestMetricTargetClone } from '../../models/harvest-metric-target-clone';
import { HarvestMetricTargetUpdateResponse } from '../../models/harvest-metric-target-update-response';

export interface CloneTargetsAndUpdate$Params {
      body: HarvestMetricTargetClone
}

export function cloneTargetsAndUpdate(http: HttpClient, rootUrl: string, params: CloneTargetsAndUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestMetricTargetUpdateResponse>> {
  const rb = new RequestBuilder(rootUrl, cloneTargetsAndUpdate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestMetricTargetUpdateResponse>;
    })
  );
}

cloneTargetsAndUpdate.PATH = '/api/metric-target/clone-and-update';
